import * as Yup from 'yup';
import { testDecimalFieldFormat } from '../../../../../helpers/helpers';
import { CHARS_AFTER_DECIMAL_POINT, CHARS_BEFORE_DECIMAL_POINT } from '../../../../../constants';

export const nameValidationSchema = Yup.object({
  name: Yup.string()
    .trim()
    .max(40, 'validation.lessThan40Chars')
    .matches(/^[^',<>#]+$/, 'validation.invalidCharactersOnName')
    .matches(/^.*[^\\]$/, 'validation.notEndBackslash')
    .required('validation.fieldRequired'),
});
export const descriptionValidationSchema = Yup.object({
  description: Yup.string()
    .trim()
    .max(128, 'validation.lessThan128Chars')
    .matches(/^[^'\\#]+$|^$/, 'validation.invalidCharactersOnDescription')
    .matches(/^.*[^\\]$|^$/, 'validation.notEndBackslash')
    .matches(/^.*[^/]$|^$/, 'validation.notEndWithSlash')
    .nullable(),
});
export const categoryValidationSchema = Yup.object({
  categoryId: Yup.number()
    .default(-1)
    .transform((value) => (Number.isNaN(value) ? -1 : value)),
});
export const priceValidationSchema = Yup.object({
  salePriceIncTax: Yup.number()
    .test('valid format', 'validation.invalidPriceFormat', (value) =>
      testDecimalFieldFormat(
        value.toString(),
        CHARS_BEFORE_DECIMAL_POINT,
        CHARS_AFTER_DECIMAL_POINT
      )
    )
    .transform((value) => (Number.isNaN(value) ? undefined : value))
    .default(0.0)
    .min(0, 'validation.greaterThan0')
    .typeError('validation.notANumber'),
  salePriceExTax: Yup.number()
    .test('valid format', 'validation.invalidPriceFormat', (value) =>
      testDecimalFieldFormat(
        value.toString(),
        CHARS_BEFORE_DECIMAL_POINT,
        CHARS_AFTER_DECIMAL_POINT
      )
    )
    .transform((value) => (Number.isNaN(value) ? undefined : value))
    .default(0.0)
    .min(0, 'validation.greaterThan0')
    .typeError('validation.notANumber'),
});

const validationSchema = nameValidationSchema
  .concat(descriptionValidationSchema)
  .concat(categoryValidationSchema)
  .concat(priceValidationSchema);

export default validationSchema;
